import React from "react";
import { useEffect } from "react";
import { fetchEncryptionData } from "./utils/utility";
import "./App.module.scss";
import { init, trackEvent } from "@airtel-web/clickstream";
import AppRoutes from "./Routes/index";
import clickStreamInstance from "./native/clickStreamWrapper";

(function () {
	clickStreamInstance().setClickStreamHitNumber(0);
})();

function App() {
	useEffect(() => {
		init({
			appName: "self-kyc",
			apiEnv: "PROD",
		});
		const windowCopy = window;
		if (!windowCopy.ClickStream) {
			windowCopy.ClickStream = {};
		}
		windowCopy.ClickStream.trackEvent = trackEvent;
		fetchEncryptionData();
	}, []);

	return <AppRoutes />;
}

export default App;
